import { fetcher } from "@website/fetcher/fetcher";
import {
  AuthVerifyOtpBodyType,
  AuthVerifyOtpResponseType
} from "@website/widget/login/services/auth-b2b-verify-otp/auth-b2b-verify-otp.types";
import { BASE_URL_PROFILE } from "@website/widget/login/services/urls";

export const AuthVerifyOtpUrl = `${BASE_URL_PROFILE}/b2b/auth/otp`;

export const AuthB2BVerifyOtpService = (
  data: AuthVerifyOtpBodyType
): Promise<AuthVerifyOtpResponseType> =>
  fetcher({
    url: AuthVerifyOtpUrl,
    method: "POST",
    data: { ...data }
  }).then(({ data }) => data);
